import { useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { Button } from "@mui/material";
import CustomInput from "../../../../../components/custom/input";
import CustomButton from "../../../../../components/custom/button";
import {
  addOrUpdateCartAsync,
  fetchCartListAsync,
  removeItemFromCartAsync,
} from "../../../../../../app/slices/cartSlice/CartSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import ConfirmationDialog from "../../../../../components/custom/confirm";
import { redirect, useNavigate } from "react-router-dom";
import CustomDialog from "../../../../../components/custom/dialog";
import { CouponComponent } from "./CouponCodes";

export const MyCart = () => {
  const [quantities, setQuantities] = useState<{ [skuId: number]: number }>({});
  const { addTocart } = useAppSelector((state) => state.CartState);
  const billingData = addTocart.billingData;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmId, setConfirmId] = useState("");
  const navigate = useNavigate();
  const [modalType, setModalType] = useState("");

  useEffect(() => {
    const quantities = addTocart?.data?.reduce((acc: any, item: any) => {
      acc[item.sku_id] = item.quantity;
      return acc;
    }, {});
    setQuantities(quantities);
  }, [addTocart?.data]);

  const dispatch = useAppDispatch();
  const openDialog = (id: any) => {
    setConfirmId(id);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setConfirmId("");
    setDialogOpen(false);
  };
  const confirmAction = () => {
    handleRemoveClick(confirmId);
    closeDialog();
  };
  const handleQuantityChange = (
    skuId: number | undefined,
    action: "increase" | "decrease",
    cart_item_id: number
  ) => {
    if (skuId === undefined) return;

    setQuantities((prevQuantities) => {
      const currentQuantity = prevQuantities[skuId] || 0;
      const maxQuantity = Infinity;

      const newQuantity =
        action === "increase"
          ? Math.min(currentQuantity + 1, maxQuantity)
          : Math.max(currentQuantity - 1, 0);

      if (newQuantity === 0) {
        dispatch(removeItemFromCartAsync(cart_item_id)).then(
          (response: any) => {
            if (response?.payload?.status === 200) {
              const aId = localStorage.getItem("aId");
              const accessToken = localStorage.getItem("accessToken");
              const anonymous_id = accessToken ? null : aId ? aId : null;

              dispatch(fetchCartListAsync(anonymous_id));
              // dispatch(fetchCartListAsync());
              navigate("/");
            }
          }
        );
      } else if (newQuantity !== currentQuantity) {
        const updatedQuantities = Object.entries(prevQuantities).map(
          ([sku, quantity]) => {
            if (Number(sku) === skuId) {
              return { sku: Number(sku), quantity: newQuantity };
            } else {
              return { sku: Number(sku), quantity };
            }
          }
        );

        const payload: any = {
          skus: updatedQuantities,
        };
        const aId = localStorage.getItem("aId");
        const accessToken = localStorage.getItem("accessToken");
        if (aId && accessToken == null) {
          payload.anonymous_id = aId;
        }
        dispatch(addOrUpdateCartAsync(payload));
      }
      return {
        ...prevQuantities,
        [skuId]: newQuantity, // Update the quantity for the SKU
      };
    });
  };
  const handleRemoveClick = (cart_item_id: any) => {
    dispatch(removeItemFromCartAsync(cart_item_id)).then((response: any) => {
      if (response?.payload?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Item removed succesfuly.",
            severity: "success",
            autoHide: 2000,
          })
        );
        if (addTocart?.data.length === 1 || addTocart?.data.length === 0) {
          navigate("/");
        }
        // dispatch(fetchCartListAsync());
        const aId = localStorage.getItem("aId");
        const accessToken = localStorage.getItem("accessToken");
        const anonymous_id = accessToken ? null : aId ? aId : null;

        dispatch(fetchCartListAsync(anonymous_id));
      } else {
        dispatch(
          showSnackbar({
            message: "Please try again later.",
            severity: "error",
            autoHide: 3000,
          })
        );
      }
    });
  };
  const onCloseModal = () => {
    setModalType("");
  };
  const removeCoupon = () => {
    const payload: any = {
      skus: Object.entries(quantities)?.map(([sku, quantity]) => ({
        sku: Number(sku),
        quantity,
      })),
      remove_coupon: true,
    };
    dispatch(addOrUpdateCartAsync(payload));
  };
  return (
    <>
      <div className="tf-mini-cart-wrap card pt-4">
        <div
          style={{
            fontFamily: "Albert Sans, sans-serif",
          }}
          className="tf-mini-cart-main"
        >
          <h5 className="px-4 ms-2 fs-20 fw-6">My cart</h5>
          <div style={{ padding: 20 }} className="tf-mini-cart-sroll">
            <div className="tf-mini-cart-items">
              {addTocart?.data?.map((item: any) => {
                return (
                  <div className="tf-mini-cart-item" key={item.sku_id}>
                    <div className="tf-mini-cart-image">
                      <a>
                        <img
                          src={`${process.env.REACT_APP_API_URL}${item?.product_image}`}
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="tf-mini-cart-info">
                      <span className="title link">
                        {item?.sku_name}-{item?.sku_quantity} {item?.sku_unit}
                      </span>
                      <div className="price fw-6">₹{item?.offer_price}</div>
                      <div className="tf-mini-cart-btns">
                        <div className="wg-quantity small">
                          <Button
                            onClick={() =>
                              handleQuantityChange(
                                item.sku_id,
                                "decrease",
                                item.cart_item_id
                              )
                            }
                            className="btn-quantity minus-btn"
                            style={{
                              cursor:
                                quantities[item.sku_id] > 0
                                  ? "pointer"
                                  : "not-allowed",
                            }}
                          >
                            -
                          </Button>
                          <input
                            type="text"
                            value={quantities[item.sku_id] || 0}
                            readOnly
                          />
                          <Button
                            onClick={() =>
                              handleQuantityChange(
                                item.sku_id,
                                "increase",
                                item.cart_item_id
                              )
                            }
                            className="btn-quantity plus-btn"
                          >
                            +
                          </Button>
                        </div>
                        <div
                          className="tf-mini-cart-remove"
                          onClick={
                            () => openDialog(item.cart_item_id)
                            // () => handleRemoveClick(item.cart_item_id)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          Remove
                        </div>
                        <ConfirmationDialog
                          title="Confirm Action"
                          open={dialogOpen}
                          onClose={closeDialog}
                          onConfirm={confirmAction}
                          content="Are you sure you want to remove this item from cart?"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div style={{ padding: 20 }} className="tf-mini-cart-bottom">
          <div
            style={{ fontFamily: "Albert Sans, sans-serif" }}
            className="tf-mini-cart-bottom-wrap"
          >
            {/* commented on 12/02  */}
            {/* <div className="coupon-box">
            <CustomInput
              label="Coupon code"
              name="couponcode"
              size="small"
              variant="outlined"
              fullWidth
            />
            <CustomButton size="small" name="Apply" />
          </div>
          <div className="tf-page-cart-note">
            <textarea
              name="note"
              rows={1}
              id="cart-note"
              placeholder="''Add Suggestions? we will pass on..''"
            ></textarea>
          </div> */}
            {localStorage.getItem("accessToken") !== "" &&
              localStorage.getItem("accessToken") !== null &&
              localStorage.getItem("accessToken") !== undefined && (
                <>
                  <a
                    className="tf-btn  animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note orange-txt"
                    onClick={() => setModalType("couponCode")}
                  >
                    <span>
                      <i className="fa fa-birthday-cake"></i> Apply Coupon
                    </span>
                  </a>
                  {billingData?.coupon_code && (
                    <div className="coupon-d">
                      <div className="row align-items-center justify-content-between">
                        <div className="col-8">
                          <p>
                            {billingData?.coupon_code} <br />
                            <small style={{ fontSize: "12px", color: "#ccc" }}>
                              Offer applied on the bill
                            </small>
                          </p>
                        </div>
                        <div className="col-4 text-end">
                          <a onClick={() => removeCoupon()}>
                            <b>REMOVE</b>
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}

            {/* <div className="tf-page-cart-note">
              <textarea
                name="note"
                rows={1}
                id="cart-note"
                placeholder="''Add Suggestions? we will pass on..''"
              ></textarea>
            </div> */}
            <h3 className="mt-3">Bill Details</h3>
            <div className="tf-cart-totals-discounts">
              <div className="tf-cart-total">Item Total</div>
              <div className="tf-totals-total-value fw-6">
                ₹{billingData.subtotal}
              </div>
            </div>
            <div className="tf-cart-totals-discounts">
              <div>Delivery fee </div>
              <div>₹{billingData.delivery_fee} </div>
            </div>
            <hr />
            {/* commented on 12/02  */}

            {/* <div className="tf-cart-totals-discounts">
              <div>Delivery Tip</div>
              <div>
                <a href="#" className="orange-txt">
                  Add tip
                </a>
              </div>
            </div> */}
            {/* <div className="tf-cart-totals-discounts">
              <div>Platform Fee</div>
              <div>₹10.00</div>
            </div> */}
            <div className="tf-cart-totals-discounts">
              <div>GST and Restaurant charges</div>
              <div>₹{billingData.taxes_and_charges}</div>
            </div>
            <hr />
            <div className="tf-cart-totals-discounts">
              <div className="tf-cart-total fw-6">To Pay</div>
              <div className="tf-totals-total-value fw-6">
                ₹{billingData.grand_total}
              </div>
            </div>
            {/* commented on 12/02  */}

            <div className="tf-mini-cart-view-checkout">
              <div className="tf-btn animate-hover-btn radius-3 w-100 justify-content-center orange-b btn-add-note">
                <span>Savings of ₹{billingData.total_savings}</span>
              </div>
            </div>
            <div className="mt-2">
              <p>
                <b>
                  Review your order and address details to avoid cancellations.
                </b>
              </p>
              <p>
                Note: Please ensure your address and order details are correct.
                This order, if cancelled, is no refundable
              </p>
              <p>
                <a href="#" className="orange-txt">
                  <b>Read Policy</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <CustomDialog
        component={
          <CouponComponent modalType={modalType} onCloseModal={onCloseModal} />
        }
        title=""
        openDialog={modalType === "couponCode"}
        handleCloseDialog={onCloseModal}
        modalPlace="right"
      />
    </>
  );
};
